import React, {useState} from "react";
import {Form, Row, Col, Card, Select, notification, DatePicker, Button} from 'antd';
import jsonfile from './migration.json';
import {CisUI} from '../../../../util/CISUI';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import {useHistory} from "react-router-dom";
import IntlMessages from "../../../../util/IntlMessages";
import 'react-smart-data-table/dist/react-smart-data-table.css'
import SelectData from "../../../../util/selectdata";
import moment from "moment/moment";


const { Option } = Select;

const NewMigrationRequest = (props) => {

    const formRef = React.createRef();
    const [companyLevel, setCompanyLevel] = useState(0);
    const [local, setLocal] = useState([]);
    const [district, setDistrict] = useState([]);
    const [destinationDistrict, setDestinationDistrict] = useState([]);

    const [display, setDisplay] = useState({
        region: "none",
        district: "none",
        local: "none",
        destinationRegion: "none",
        destinationDistrict: "none",
    });
    const [required, setRequired] = useState({
        region: false,
        district: false,
        local: false,
        destinationRegion: false,
        destinationDistrict: false,
    });

    const AccountsLevel = SelectData("accounts/accountslevel");
    const Regions = SelectData("regions");

    const [form] = Form.useForm();

    const history = useHistory();


    let Title = jsonfile.addtitle;
    let endpoint = "company/newmigrationrequest";
    let redirectTo = "../"+jsonfile.urls.list;

    const onFinish = (values) => {
        // setLoading({loading:true})
        let data = {
            ...values,
            'effective_date': moment(values?.effective_date).format('YYYY-MM-DD'),
        };

        document.getElementById("loader").style.display = "block";

        axios.post(Config.apiserver + endpoint, data)
            .then(res => {
                // console.log(res)
                document.getElementById("loader").style.display = "none";
                if (res.data.status === 1) {
                    notification.success({
                        message: 'Success',
                        type: "warning",
                        description: res.data.msg
                    });
                    history.push(redirectTo);
                } else {
                    notification.warning({
                        message: 'Alert',
                        type: "warning",
                        description: res.data.msg
                    });
                }
            })
            .catch(errors => {
                if(document.getElementById("loader") !== undefined) {
                    document.getElementById("loader").style.display = "none";
                }
                console.log(errors);
            });

    };


    const onAreaChange = value => {
        setCompanyLevel(value);

        form.setFieldsValue({ region: null });
        form.setFieldsValue({ district: null });
        form.setFieldsValue({ local: null });
        form.setFieldsValue({ destination_region: null });
        form.setFieldsValue({ destination_district: null });

        if(value === 5) {
            setDisplay({
                region: "block",
                district: "block",
                local: "none",
                destinationRegion: "block",
                destinationDistrict: "none"
            });
            setRequired({
                region: true,
                district: true,
                local: false,
                destinationRegion: true,
                destinationDistrict: false
            })
        }
        else if(value === 6) {
            setDisplay({
                region: "block",
                district: "block",
                local: "block",
                destinationRegion: "block",
                destinationDistrict: "block"
            });
            setRequired({
                region: true,
                district: true,
                local: true,
                destinationRegion: true,
                destinationDistrict: true
            })
        }

    };

    const onRegionChange = value => {
        form.setFieldsValue({ district: null });
        axios.get("districtsbyregion/"+value)
            .then((res) => {
                if (res.data.status === 1) {
                    const districtList = res.data.data;
                    setDistrict(districtList);
                }
                else{
                    CisUI().showAlert("Alert","warning", res?.data?.msg);
                }
            })
            .catch(errors => {console.log(errors);})
    };

    const onDestinationRegionChange = value => {
        form.setFieldsValue({ destination_district: null });
        if(companyLevel === 6) {
            axios.get("districtsbyregion/" + value)
                .then((res) => {
                    if (res.data.status === 1) {
                        const districtList = res.data.data;
                        setDestinationDistrict(districtList);
                    }
                    else{
                        CisUI().showAlert("Alert","warning", res?.data?.msg);
                    }
                })
                .catch(errors => {
                    console.log(errors);
                })
        }
    };

    const onDistrictChange = value => {
        // console.log(companyLevel);
        // console.log(typeof companyLevel);
        form.setFieldsValue({ local: null });
        if(companyLevel === 6) {
            axios.get("localsbydistrict/" + value)
                .then((res) => {
                    if (res.data.status === 1) {
                        const locallist = res.data.data;
                        setLocal(locallist);
                    }
                    else{
                        CisUI().showAlert("Alert","warning", res?.data?.msg);
                    }
                })
                .catch(errors => {
                    console.log(errors);
                })
        }
    };


    return (
        <>
            <Card title={<IntlMessages id={Title}/>} extra={CisUI().addAction(redirectTo)}>
                {CisUI().showLoading}
                <Form
                    form={form}
                    ref={formRef}
                    {...CisUI().formItemLayout}
                    name="input"
                    className="ant-advanced-search-form"
                    onFinish={onFinish}
                >

                    <Row>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <Card title="Source Entity">
                                <Row>
                                    <Col lg={12} md={12} sm={24} xs={24}>
                                        <div className="gx-form-row0">
                                            <Form.Item
                                                name="area"
                                                label={<IntlMessages id="Level of Department/Branch"/>}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Select level of Department/Branch"
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Select level of Department/Branch"
                                                    optionFilterProp="children"
                                                    onChange={onAreaChange}
                                                    filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                                >
                                                    {
                                                        AccountsLevel.map((items, index) =>
                                                            (parseInt(items?.id) === 5 || parseInt(items?.id) === 6) &&
                                                            <Option key={++index} value={items?.id}>{items?.name}</Option>
                                                        )
                                                    }
                                                </Select>
                                            </Form.Item>

                                        </div>
                                    </Col>

                                    <Col lg={12} md={12} sm={24} xs={24} id="region" style={{display: display.region}}>
                                        <div className="gx-form-row0">
                                            <Form.Item
                                                name="region"
                                                label={<IntlMessages id="Area"/>}
                                                rules={[
                                                    {
                                                        required: required.region,
                                                        message: "Select an area"
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Select an area"
                                                    optionFilterProp="children"
                                                    onChange={onRegionChange}
                                                    filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                                >
                                                    {
                                                        Regions.map((items, index) =>
                                                            <Option key={++index} value={items.id}>{items.name}</Option>
                                                        )
                                                    }
                                                </Select>
                                            </Form.Item>

                                        </div>
                                    </Col>

                                    <Col lg={12} md={12} sm={24} xs={24} id="district" style={{display: display.district}}>
                                        <div className="gx-form-row0">
                                            <Form.Item
                                                name="district"
                                                label={<IntlMessages id="District"/>}
                                                rules={[
                                                    {
                                                        required: required.district,
                                                        message: "Select a district"
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Select District"
                                                    optionFilterProp="children"
                                                    onChange={onDistrictChange}
                                                    filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                                >
                                                    {
                                                        district?.map((items, index) =>
                                                            <Option key={++index} value={items.id}>{items.name}</Option>
                                                        )
                                                    }
                                                </Select>
                                            </Form.Item>

                                        </div>
                                    </Col>

                                    <Col lg={12} md={12} sm={24} xs={24} id="local" style={{display: display.local}}>
                                        <div className="gx-form-row0">
                                            <Form.Item
                                                name="local"
                                                label={<IntlMessages id="Local Assembly"/>}
                                                rules={[
                                                    {
                                                        required: required.local,
                                                        message: "Select a local assembly"
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Select Local"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                                >
                                                    {
                                                        local.map((items, index) =>
                                                            <Option key={++index} value={items.id}>{items.name}</Option>
                                                        )
                                                    }
                                                </Select>
                                            </Form.Item>

                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <Card title="Destination Entity">
                                <Row>
                                    <Col lg={12} md={12} sm={24} xs={24}>
                                        <div className="gx-form-row0">
                                            <Form.Item
                                                name="effective_date"
                                                label="Effective Date"
                                                initialValue={moment()}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Effective Date is required",
                                                    },
                                                ]}
                                            >
                                                <DatePicker format={CisUI().dateFormat}
                                                            className="gx-w-100"
                                                            placeholder="Date"/>
                                            </Form.Item>
                                        </div>
                                    </Col>

                                    <Col lg={12} md={12} sm={24} xs={24} id="destinationregion" style={{display: display.destinationRegion}}>
                                        <div className="gx-form-row0">
                                            <Form.Item
                                                name="destination_region"
                                                label={<IntlMessages id="Area"/>}
                                                rules={[
                                                    {
                                                        required: required.destinationRegion,
                                                        message: "Select an area"
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Select an area"
                                                    optionFilterProp="children"
                                                    onChange={onDestinationRegionChange}
                                                    filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                                >
                                                    {
                                                        Regions?.map((items, index) =>
                                                            <Option key={++index} value={items.id}>{items.name}</Option>
                                                        )
                                                    }
                                                </Select>
                                            </Form.Item>

                                        </div>
                                    </Col>

                                    <Col lg={12} md={12} sm={24} xs={24} id="destinationdistrict" style={{display: display.destinationDistrict}}>
                                        <div className="gx-form-row0">
                                            <Form.Item
                                                name="destination_district"
                                                label={<IntlMessages id="District"/>}
                                                rules={[
                                                    {
                                                        required: required.destinationDistrict,
                                                        message: "Select a district"
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Select District"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                                >
                                                    {
                                                        destinationDistrict?.map((items, index) =>
                                                            <Option key={++index} value={items.id}>{items.name}</Option>
                                                        )
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <div className="col-md-12" style={{textAlign: 'center', marginTop : '30px'}}>
                            <Button id="submitbutton" type="primary" htmlType="submit">
                                Submit
                            </Button>
                            <Button id="resetButton" type="primary" htmlType="reset">Reset</Button>
                            <Button type="info" onClick={() => history.goBack()} htmlType="back">Cancel</Button>
                        </div>
                    </Row>


                </Form>

            </Card>

        </>
    );
};

export default NewMigrationRequest;